// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (min-width: 1025px) and (min-height: 769px) {
  app-footer {
    position: relative;
    z-index: 1;
  }
  ion-app {
    z-index: 10;
  }
  .content {
    height: calc(100vh - 120px - 75px);
    max-height: calc(100vh - 120px - 75px);
    /*  height: calc(100vh - 90px - 75px);
    max-height: calc(100vh - 90px - 75px); */
    /* height: calc(100vh - 120px - 110px);
    max-height: calc(100vh - 120px - 110px); */
    background-color: #455e72;
  }
  .menu {
    min-width: 199px;
  }
}
@media (min-width: 1025px) and (max-height: 768px) {
  app-footer {
    position: relative;
    z-index: 1;
  }
  ion-app {
    z-index: 10;
  }
  .content {
    height: calc(100vh - 75px - 66px);
    max-height: calc(100vh - 75px - 66px);
    /* height: calc(100vh - 40px - 66px);
    max-height: calc(100vh - 40px - 66px); */
    /* height: calc(100vh - 75px - 101px);
    max-height: calc(100vh - 75px - 101px); */
    background-color: #455e72;
  }
  .menu {
    min-width: 199px;
  }
}
@media (max-width: 1025px) {
  app-header,
  app-footer {
    display: none;
  }
  .content {
    height: 100vh;
    max-height: 100vh;
  }
  .menu {
    width: 182px;
  }
}
.imgTitle {
  width: 50px;
  height: 50px;
  margin-left: 55px;
  margin-top: 15px;
}

.itemMenu {
  font-size: 12px;
  height: 32px;
}

.itemMenu2 {
  font-size: 12px;
  height: 24px;
}

.subPages {
  font-size: 10px;
  margin-top: -17px;
  margin-left: 8px;
}

.online {
  border-top: 1px solid gray;
}

.emptyItem {
  height: 30px;
}

ion-split-pane ion-menu ion-content {
  --background: rgba(225, 225, 225);
}
ion-split-pane ion-menu ion-content .listU {
  height: 672px;
}
ion-split-pane ion-menu ion-content .listU ion-list-header {
  --background: rgba(225, 225, 225) !important;
  --color: black !important;
  margin-top: -8px;
}
ion-split-pane ion-menu ion-content .listU ion-item {
  --background: rgba(225, 225, 225) !important;
  --color: black !important;
}

@media (min-width: 600px) {
  ion-list-header {
    display: none;
  }
  ion-split-pane ion-menu ion-content {
    --background: rgba(225, 225, 225);
  }
  ion-split-pane ion-menu ion-content .listU {
    height: 607px;
    padding-top: 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/app.component.scss"],"names":[],"mappings":"AAAA;EAGE;IACE,kBAAA;IACA,UAAA;EADF;EAIA;IAEE,WAAA;EAHF;EAMA;IAEE,kCAAA;IACA,sCAAA;IAGA;4CAAA;IAIA;8CAAA;IAEA,yBAAA;EATF;EAYA;IACE,gBAAA;EAVF;AACF;AAcA;EAGE;IACE,kBAAA;IACA,UAAA;EAdF;EAiBA;IAEE,WAAA;EAhBF;EAmBA;IAGE,iCAAA;IACA,qCAAA;IAGA;4CAAA;IAIA;6CAAA;IAEA,yBAAA;EAvBF;EA0BA;IACE,gBAAA;EAxBF;AACF;AA2BA;EAEE;;IAEE,aAAA;EA1BF;EA4BA;IAGE,aAAA;IACA,iBAAA;EA5BF;EA+BA;IACE,YAAA;EA7BF;AACF;AAgCA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;AA9BF;;AAiCA;EACE,eAAA;EACA,YAAA;AA9BF;;AAmCA;EACE,eAAA;EACA,YAAA;AAhCF;;AAmCA;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;AAhCF;;AAkCA;EACE,0BAAA;AA/BF;;AAiCA;EACE,YAAA;AA9BF;;AAmCI;EAEE,iCAAA;AAjCN;AAmCM;EACE,aAAA;AAjCR;AAmCQ;EAGE,4CAAA;EACA,yBAAA;EACA,gBAAA;AAnCV;AAsCQ;EAEE,4CAAA;EACA,yBAAA;AArCV;;AA6CA;EACE;IACE,aAAA;EA1CF;EA+CI;IAEE,iCAAA;EA9CN;EAgDM;IACE,aAAA;IACA,cAAA;EA9CR;AACF","sourcesContent":["@media (min-width: 1025px) and (min-height: 769px) {\n  //excede de 600 pc grande\n\n  app-footer {\n    position: relative;\n    z-index: 1;\n  }\n\n  ion-app {\n    //position: relative;\n    z-index: 10;\n  }\n\n  .content {\n    //normal\n    height: calc(100vh - 120px - 75px);\n    max-height: calc(100vh - 120px - 75px);\n\n    //sobre el header\n    /*  height: calc(100vh - 90px - 75px);\n    max-height: calc(100vh - 90px - 75px); */\n\n    //sobre el footer\n    /* height: calc(100vh - 120px - 110px);\n    max-height: calc(100vh - 120px - 110px); */\n    background-color: #455e72;\n  }\n\n  .menu {\n    min-width: 199px;\n  }\n}\n\n//pc mediano\n@media (min-width: 1025px) and (max-height: 768px) {\n  //excede de 600\n\n  app-footer {\n    position: relative;\n    z-index: 1;\n  }\n\n  ion-app {\n    //position: relative;\n    z-index: 10;\n  }\n\n  .content {\n    //normal\n\n    height: calc(100vh - 75px - 66px);\n    max-height: calc(100vh - 75px - 66px);\n\n    //sobre el header\n    /* height: calc(100vh - 40px - 66px);\n    max-height: calc(100vh - 40px - 66px); */\n\n    //sobre el footer\n    /* height: calc(100vh - 75px - 101px);\n    max-height: calc(100vh - 75px - 101px); */\n    background-color: #455e72;\n  }\n\n  .menu {\n    min-width: 199px;\n  }\n}\n\n@media (max-width: 1025px) {\n  //debajo de 600\n  app-header,\n  app-footer {\n    display: none;\n  }\n  .content {\n    //height: 400px;\n    //max-height: 400px;\n    height: 100vh;\n    max-height: 100vh;\n  }\n\n  .menu {\n    width: 182px;\n  }\n}\n\n.imgTitle {\n  width: 50px;\n  height: 50px;\n  margin-left: 55px;\n  margin-top: 15px;\n}\n\n.itemMenu {\n  font-size: 12px;\n  height: 32px;\n  //background-color: white !important;\n  //color: black;\n}\n\n.itemMenu2 {\n  font-size: 12px;\n  height: 24px;\n}\n\n.subPages {\n  font-size: 10px;\n  margin-top: -17px;\n  margin-left: 8px;\n}\n.online {\n  border-top: 1px solid gray;\n}\n.emptyItem {\n  height: 30px;\n}\n\nion-split-pane {\n  ion-menu {\n    ion-content {\n      //--background: rgba(225, 225, 225) !important;\n      --background: rgba(225, 225, 225);\n\n      .listU {\n        height: 672px;\n\n        ion-list-header {\n          //--background: rgb(211, 211, 211) !important;\n          //--background: rgba(218, 218, 218) !important;\n          --background: rgba(225, 225, 225) !important;\n          --color: black !important;\n          margin-top: -8px;\n        }\n\n        ion-item {\n          //--background: rgb(211, 211, 211) !important;\n          --background: rgba(225, 225, 225) !important;\n          --color: black !important;\n          //ion-icon{ padding-right: 10px !important; }\n        }\n      }\n    }\n  }\n}\n\n@media (min-width: 600px) {\n  ion-list-header {\n    display: none;\n  }\n\n  ion-split-pane {\n    ion-menu {\n      ion-content {\n        //--background: rgba(225, 225, 225) !important;\n        --background: rgba(225, 225, 225);\n\n        .listU {\n          height: 607px;\n          padding-top: 0;\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
